<div class="layout-footer">
    <img src="assets/layout/images/bewire-logo-circle.png" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">Bewire</span>
</div>
